import { createSvgIcon } from "@mui/material";

export const DownloadIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="70 60 145 165" fill="currentColor">
        <g>
            <polygon points="166.12,120.52 166.12,71.74 117.35,71.74 117.35,120.52 84.01,120.52 141.73,178.24 199.46,120.52"/>
            <rect x="84.01" y="193.92" width="115.45" height="17.8"/>
        </g>
    </svg>,
    'DownloadIcon'
)
